"use client"

import * as React from "react"
import { cn } from "../lib/utils.ts"
import { Progress as ProgressPrimitive } from "radix-ui"

/*
 * shadcn/ui Progress, restyled: the meter track and the accent fill (progress of the user's
 * own action, colour.md). The bar moves with the value; nothing else animates.
 */
function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={value}
      className={cn(
        "relative h-(--meter-track-height) w-full overflow-hidden rounded-full bg-(--meter-track)",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="h-full w-full flex-1 bg-(--meter-fill) prism-ray-progress transition-transform duration-(--duration-base) ease-standard"
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  )
}

export { Progress }
